import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/47_halloween_fog/47_halloween_fog"
 * Contains 1 texture(s)
 */
export class Tablet47HalloweenFogAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/47_halloween_fog/47_halloween_fog';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '47_halloween_fog.jpg'
    ] as const;
}
